var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 26,
    viewBox: "0 0 157 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26H4V0H0V26ZM29.665 0V17.994L16.131 0H12V26H16.375V7.5L30.32 26H34V0H29.665ZM40 0V26H44.74V15.423H58.26V11.25H44.74V4.17H60V0H40ZM65 26H69V0H65V26ZM94.657 0V17.994L81.097 0H77V26H81.343V7.5L95.313 26H99V0H94.657ZM151.478 0L145.083 9.439L138.689 0H133.374L142.26 12.768L133 26H138.19L144.917 16.097L151.685 26H157L147.699 12.684L156.626 0H151.478Z",
    fill: "#959183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.582 22.41L117.959 17.086L114.335 22.368C115.48 22.8547 116.71 23.1091 117.954 23.1163C119.198 23.1235 120.431 22.8834 121.582 22.41Z",
    fill: "#A5B1D3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1323_5735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 0,
    width: 28,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.287 0.123001H131.59V25.918H104.287V0.123001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1323_5735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 0.123997C116.17 0.104168 114.354 0.447784 112.658 1.13493C110.962 1.82207 109.419 2.83908 108.118 4.127C105.648 6.686 104.248 10.111 104.288 13.66V13.743C104.249 16.2857 104.942 18.7861 106.286 20.9451C107.629 23.1042 109.566 24.8306 111.865 25.918L114.335 22.327C111.082 20.883 108.982 17.457 108.982 13.66V13.578C108.982 8.254 112.812 4.251 117.918 4.251C120.348 4.21 122.694 5.241 124.382 7.016C126.037 8.82908 126.935 11.206 126.894 13.66V13.743C126.894 17.581 124.794 20.965 121.541 22.368L123.929 25.876C128.665 23.648 131.671 18.86 131.589 13.66V13.578C131.606 11.8218 131.276 10.0796 130.619 8.45097C129.961 6.82231 128.99 5.33907 127.759 4.086C125.206 1.486 121.664 0.082997 118 0.123997Z",
    fill: "#959183"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinox);
export default __webpack_public_path__ + "static/media/infinox.adf8f395ebc6600b7c5e4b1378d40359.svg";
export { ForwardRef as ReactComponent };